/* eslint-disable react/jsx-props-no-spreading */
import { inMarketTheme } from '@inmarket/inmarkit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

type AccordionSectionProps = {
  children?: React.ReactNode;
  openTitle?: string;
  closedTitle?: string;
  isOpen?: boolean;
  [key: string]: any;
};

function AccordionSection({
  children,
  openTitle = 'Less Settings',
  closedTitle = 'More Settings',
  isOpen: isOpenProp = false,
  ...props
}: AccordionSectionProps) {
  const [isOpen, setIsOpen] = useState(isOpenProp);

  useEffect(() => {
    setIsOpen(isOpenProp);
  }, [isOpenProp]);

  return (
    <Grid item xs={12}>
      <Accordion {...props} sx={{ boxShadow: 'none' }} expanded={isOpen} onChange={() => setIsOpen(!isOpen)}>
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              sx={{
                color: inMarketTheme.palette.primary.main,
              }}
            />
          }
          sx={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
            '& .MuiAccordionSummary-content': {
              flexGrow: 0,
            },
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(180deg)',
            },
          }}
        >
          <Typography sx={{ color: inMarketTheme.palette.primary.main, marginRight: 2 }}>
            {isOpen ? openTitle : closedTitle}{' '}
          </Typography>
        </AccordionSummary>
        {children}
      </Accordion>
    </Grid>
  );
}

export default AccordionSection;
